"use client";

import React,{useState} from "react";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import {CWFInput} from "@/components/ui/CWFInput";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {Form} from "@/components/ui/form";
import {usePathname} from "next/navigation";
import {
    FacebookIcon,
    FacebookShareButton, LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton, WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import {Button} from "@/components/ui/button";
import {FaCopy} from "react-icons/fa";
import toast from "react-hot-toast";

export default function ShareAction({trigger,...props}){
    const [open,setOpen] = useState(false);
    const pathname = usePathname();
    const URL = process.env.NEXT_PUBLIC_URL + pathname


    function handleClick(){
        setOpen(true);
    }

    const formShema = yup.object({
        url : yup.string(),
    })
    const form = useForm({
        resolver : yupResolver(formShema),
        defaultValues : {url : URL}
    })

    function copyUrl(data){
        navigator.clipboard.writeText(data.url);
        toast.success("Lien copié avec succès");
    }

    return(
        <>
            {trigger ? (
                React.cloneElement(trigger, {onClick: handleClick})
            ):<></>}

            <CWFResponsiveDialog
                open={open}
                onOpenChange={setOpen}
                title={<p className={"text-center"}>Partager cet évènement</p>}
                description={<p className={"italic text-center text-sm"}>Parlez en a vos amis</p>}
                trigger={null}
                {...props}
            >
                <Form {...form}>
                    <form className={"flex gap-x-2"} onSubmit={form.handleSubmit(copyUrl)}>
                        <CWFInput control={form.control} name={"url"} disabled/>
                        <Button type={"submit"}><FaCopy/></Button>
                    </form>

                </Form>
                <div className={"flex justify-center gap-x-4 pt-2 md:pt-0"}>
                    <FacebookShareButton url={URL}>
                        <FacebookIcon round={true} size={32}/>
                    </FacebookShareButton>
                    <TwitterShareButton url={URL}>
                       <TwitterIcon round={true} size={32}/>
                    </TwitterShareButton>
                    <LinkedinShareButton url={URL}>
                        <LinkedinIcon round={true} size={32}/>
                    </LinkedinShareButton>
                    <WhatsappShareButton url={URL}>
                        <WhatsappIcon round={true} size={32}/>
                    </WhatsappShareButton>
                </div>
            </CWFResponsiveDialog>
        </>
    )
}
